// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { QueryTables_abstract } from './../../abstract/SagaBase/Objects/QueryTables_abstract';
export class QueryTables extends QueryTables_abstract {}
